import React from 'react';
import ENTRY_STATUS from '../../constants/entry-status';

const classNameBy = status => {
  switch (status) {
    case ENTRY_STATUS.CODE.ORDERED:
      return 'is-success';
    case ENTRY_STATUS.CODE.SHIPPED:
      return 'is-info';
    case ENTRY_STATUS.CODE.REGISTERED:
      return 'is-link';
    case ENTRY_STATUS.CODE.DOWNLOAD_AVAILABLE:
      return 'is-primary';
    case ENTRY_STATUS.CODE.DOWNLOADED:
      return 'is-light';
    default:
      return '';
  }
};

const EntryStatus = ({ status, isRefunded, desktopFontSize, mobileFontSize }) => {
  return isRefunded ? (
    <span
      className={`has-text-weight-bold has-text-weight-normal-mobile tag ${desktopFontSize || 'is-size-6'} ${mobileFontSize || 'is-size-7-mobile'}`}
    >
        <span>キャンセル</span>
      </span>
    ) : (
    <span>
      <span
        className={`has-text-weight-bold has-text-weight-normal-mobile tag ${desktopFontSize || 'is-size-6'} ${mobileFontSize || 'is-size-7-mobile'} ${classNameBy(status)}`}
      >
        {status ? <span>{ENTRY_STATUS.name(status)}</span> : <span>読込中</span>}
      </span>
    </span>
  );
};

export default EntryStatus;